import isUrl from 'is-url';

export default function isValidUrl(url: unknown): boolean {
    return !!(url && typeof url === 'string' && isUrl(url));
}
